<div #successToast role="alert" aria-live="assertive" aria-atomic="true" class="toast fade position-fixed bottom-0 end-0 p-3" 
[class.bg-success]="isSuccess"
[class.bg-danger]="isFailure"
data-bs-autohide="false">
    <div class="toast-body d-flex justify-content-between">
        <div>{{message}}</div>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria- label="Close"></button>
    </div>
</div>